import AxiosConfig from '../../../config/AxiosConfig';

const useSystemUpdate = () => {
  const systemUpdate = async (update) => {
    try {
      const res = AxiosConfig.create('put', '/system/update/')
        .call(update)
        .getResponseData();
      return res;
    } catch (err) {
      console.error('Failed to update system:', err);
      throw new Error(`System update failed: ${err.message}`);
    }
  };
  return { systemUpdate };
};

export default useSystemUpdate;
